import { FC } from "react";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs } from "@mui/material";
import { CustomBreadcrumb } from "../../components/common/CustomBreadcrumb/CustomBreadcrumb";
import { RoutesMap } from "../../types";

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const Planes = [
    { id: 1, name: 'Basic', key: 'basic' },
    { id: 2, name: 'Standar', key: 'standar' },
    { id: 3, name: 'Pro', key: 'pro' },
]

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Planes', pathname: RoutesMap.PLANS_LIST }
]

export const PlanList: FC = () => {


    const navigate = useNavigate()

    const onDetails = (rowSelected) => {
        navigate(`/plan-initial-step-list/${rowSelected.key}`)
    }

    return (<>
        <CustomTable
            breadcrumbs={breadcrumbs}
            title={'Planes'}
            columns={columns}
            // loading={status === ApiStatus.FETCHING}
            rows={Planes || []}
            onRowClick={() => { }}
            hasOptions
            // onAddFn={onAdd}
            // onAddFnName={'Nuevo administrador'}
            onDetails={onDetails}
            // onDelete={onDelete}
            // onEdit={onEdit}
            onSearch
            dense
        />
    </>)
}